import { ProductCategoriesEnum } from './enums';

export const Routes = {
    CreateProfile:
        ({ destination, affiliateCode, email, firstName, lastName, phone, disableEmailField } = { }) => {
            const params = [];
            if (destination) params.push(`destination=${destination}`);
            if (affiliateCode) params.push(`affiliateCode=${affiliateCode}`);
            if (email) params.push(`email=${encodeURIComponent(email)}`);
            if (firstName) params.push(`firstName=${encodeURIComponent(firstName)}`);
            if (lastName) params.push(`lastName=${encodeURIComponent(lastName)}`);
            if (phone) params.push(`phone=${encodeURIComponent(phone)}`);
            if (disableEmailField) params.push(`disableEmailField=${Boolean(disableEmailField)}`);
            return `/opret?${params.join('&')}`;
        }
    ,
    MyPenly: {
        BaseUrl: '/mit-penly/',
        Advisory: {
            BookAdvisor: (productId) => `/mit-penly/raadgivning/${productId}`,
            Receipt: '/mit-penly/raadgivning/kvittering',
            SharingReceipt: '/mit-penly/raadgivning/deling-kvittering',
            ReceiptWithProductId: (productId) => `/mit-penly/raadgivning/kvittering/${productId}`,
            Sharings: '/mit-penly/raadgivning/delinger',
            Messages: '/mit-penly/raadgivning/beskeder',
            Mortgage: {
                BookAdvisor: (productId) => `/mit-penly/raadgivning/${ProductCategoriesEnum.Mortgage.urlid}/${productId}`,
                Receipt: (productId) => `/mit-penly/raadgivning/realkredit/kvittering/${productId}`,
            },
            Invest: {
                BookAdvisor: (productId) => `/mit-penly/raadgivning/${ProductCategoriesEnum.Invest.urlid}/${productId}`,
                Receipt: (productId) => `/mit-penly/raadgivning/invest/kvittering/${productId}`,
            },
            Product: {
                Flow: (product) => `/mit-penly/raadgivning/${product.affiliateId}/${product.slug}`,
                Receipt: (product) => `/mit-penly/raadgivning/kvittering/${product.affiliateId}/${product.slug}`,
            },
        },
        Receipt: (productId) => `/mit-penly/raadgivning/kvittering/${productId}`,
        Dashboard: '/mit-penly/pension',
        Pension: {
            Dashboard: '/mit-penly/pension',
            PensionCheck: '/mit-penly/pension/pensionstjek',
            PensionCheckDetails: {
                KlatPension: '/mit-penly/pension/pensionstjek/klatpension',
            },
            PensionPlans: '/mit-penly/pension/pensioner',
            Play: '/mit-penly/pension/play',
            Folkepension: '/mit-penly/pension/folkepension',
            Goals: '/mit-penly/pension/maal',
        },
        Mortgage: {
            Dashboard: '/mit-penly/realkredit',
            MortgageCheck: '/mit-penly/realkredit/realkredittjek',
        },
        Profile: {
            ProfileData: {
                Household: '/mit-penly/profil/profildata/husholdning',
                // SavingsAndDebt: '/mit-penly/profil/profildata/opsparing-og-gaeld',
                PropertiesAndDebt: '/mit-penly/profil/profildata/bolig-og-gaeld',
                Other: '/mit-penly/profil/profildata/andet',
                // Properties: '/mit-penly/profil/profildata/bolig',
                Pension: '/mit-penly/profil/profildata/pension',
                Insurance: '/mit-penly/profil/profildata/forsikring',
                // Investering: '/mit-penly/profil/profildata/investering',
                // Loans: '/mit-penly/profil/profildata/laan',
                Savings: '/mit-penly/profil/profildata/opsparing',
                // Debt: '/mit-penly/profil/profildata/gaeld',
                // Transport: '/mit-penly/profil/profildata/transport',
            },
            Settings: {
                Edit: '/mit-penly/profil/indstillinger',
                Security: '/mit-penly/profil/indstillinger/sikkerhed',
            },
            Documents: '/mit-penly/profil/dokumenter',
            Affiliations: {
                Affiliates: '/mit-penly/profil/fordele',
            },
        },
        Orders: {
            Order: (orderId) => `/mit-penly/ordrer/${orderId}`,
            BaseUrl: '/mit-penly/ordrer',
        },
    },
    Advisory: {
        Receipt: '/raadgivning/kvittering',
        BookingReceipt: '/raadgivning/booking-kvittering',
        Nedsparing: {
            Flow: '/raadgivning/nedsparingsraadgivning',
            Receipt: '/raadgivning/kvittering',
        },
        PensionCheck: {
            Flow: '/raadgivning/pensionstjekgennemgang',
            Receipt: '/raadgivning/kvittering',
        },
        FreePensionMeeting: {
            Flow: '/raadgivning/pensionsgennemgang',
            Receipt: '/raadgivning/kvittering',
        },
        EconomyCheck: {
            Flow: '/raadgivning/oekonomitjek',
            Receipt: '/raadgivning/kvittering',
        },
        PensionAdvice: {
            Flow: '/raadgivning/pensionsraadgivning',
            Receipt: '/raadgivning/kvittering',
        },
        Mortgage: {
            Flow: '/raadgivning/realkreditlaan-raadgivning',
            Receipt: '/raadgivning/kvittering',
        },
        PenlySubscription: {
            Flow: '/raadgivning/abonnement',
            Receipt: '/raadgivning/kvittering',
        },
        Investering15: {
            Flow: '/raadgivning/investering-15',
            Receipt: '/raadgivning/kvittering',
        },
    },
    PensionCheck: {
        LandingPage: '/pensionstjek',
        Start: '/pensionstjek/start',
        Play: '/pensionstjek#play',
        Feedback: '/pensionstjek/feedback',
        KlatPensionLandingPage: '/klatpension',
        Privat: '/pensionstjek-til-private',
        Independent: '/pension-til-selvstaendige',
        Firmapension: '/firmapension',
    },
    MortgageCheck: {
        LandingPage: '/realkredit',
    },
    Jura: {
        LandingPage: '/jura',
    },
    InvestCheck: {
        LandingPage: '/investering',
    },
    BudgetCheck: {
        LandingPage: '/budgettjek',
    },
    PenlyPlay: {
        LandingPage: '/play',
    },
    Formueberegner: '/omkostningsberegner',
    Services: '/vaerktoejer',
    FAQ: '/faq',
    Articles: {
        LandingPage: '/artikler',
        Article: (url) => `/artikler/${url}`,
    },
    AboutPenly: '/om-os',
    AboutAdvice: '/om-raadgivningen',
    Contact: '/kontakt',
    ForCompanies: '/for-virksomheder',
    ForPartners: '/for-partnere',
    PrivacyPolicy: '/privatlivspolitik',
    Cookies: '/cookies',
    Terms: '/betingelser',
    Logout: '/logout',
    Dictionary: {
        LandingPage: '/ordbog',
        Entry: (url) => `/ordbog/${url}`,
    },
    PenlyPanel: {
        Signup: '/penly-panelet',
    },
    Affiliates: {
        LandingPage: '/partner',
        AffiliateLandingPage: (affiliateUrl) => `/partner/${affiliateUrl}`,
    },
    Prices: '/priser',
    PensionsinfoUploadGuide: '/pensionsinfo-upload-guide',
    Knowledge: {
        LandingPage: '/viden',
        Entry: (url) => `/viden/${url}`,
    },
};
